import { render } from "./StatsModule.vue?vue&type=template&id=1d2f690a"
import script from "./StatsModule.vue?vue&type=script&lang=js"
export * from "./StatsModule.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__